import { render, staticRenderFns } from "./NetDetect.vue?vue&type=template&id=9c9106d4&scoped=true&"
import script from "./NetDetect.vue?vue&type=script&lang=js&"
export * from "./NetDetect.vue?vue&type=script&lang=js&"
import style0 from "./NetDetect.vue?vue&type=style&index=0&id=9c9106d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9106d4",
  null
  
)

export default component.exports